require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/create.js
 ** module id = 82
 ** module chunks = 1
 **/